export const properties = {
    DEFAULT_BUTTON : 'Todos',
    MISTRAMITES_BUTTON: 'Mis trámites',
    idDefaultButton: 'todos',
    idMistramites: 'misTramites'
}